/* src/app/private/components/leads/bulk-delete/bulk-delete.component.scss */
/*# sourceMappingURL=bulk-delete.component.css.map */
